import { z } from 'my-zod'
import { promotionModel } from './promotion-model'

export const promotionSystemView = promotionModel.augment({
  redemptionCount: z.number().min(0)
})
export type promotionSystemView = z.infer<typeof promotionSystemView>
